import "babel-polyfill";

import React from 'react';
import ReactGA from 'react-ga';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';

import { render } from 'react-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { get, startsWith } from 'lodash';

import { Router, hashHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';

import routes from './routes';
import reducers from './reducers';

import '@blueprintjs/core/dist/blueprint.css';
import './assets/css/bootstrap.css';
import './assets/css/style.css';
import './assets/googleapis-fonts.css';
import './assets/styles.less';
import './assets/css/prism.css';

import I18nProvider from './i18n/provider';
import messages from './i18n/messages';

require('es6-promise/auto');

import meta from '../package.json';
import { getConfig } from './config';

console.info(`[${meta.name}@${meta.version}]`);

getConfig()
  .then(config => {
    const middlewares = [thunk];

    if (process.env.NODE_ENV === 'development') {
      const logger = createLogger({ duration: true, timestamp: false, collapsed: true });
      middlewares.push(logger);
    }

    const store = createStore(
      combineReducers({
        ...reducers,
        routing: routerReducer,
        config: () => config
      }),
      applyMiddleware(...middlewares)
    );

    const history = syncHistoryWithStore(hashHistory, store);

    if(config.GATrackingID) ReactGA.initialize(config.GATrackingID);
    let lastPathname = '';
    const historyListener = (location) => {
      const _pathname = startsWith(location.pathname, '/') ? location.pathname : `/${location.pathname}`;
      if (lastPathname !== _pathname) {
        lastPathname = _pathname;
        ReactGA.set({ page: _pathname });
        ReactGA.pageview(_pathname);
      }
    };
    history.listen(historyListener);
    historyListener(window.location);

    render(
      <Provider store={store}>
        <I18nProvider messages={messages}>
          <Router history={history} routes={routes} />
        </I18nProvider>
      </Provider>,
      document.getElementById('root')
    );
  });



// WEBPACK FOOTER //
// ./src/app.js